module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-hero",
    attrs: {
      "block": "transparent"
    }
  }, [_c('div', {
    staticClass: "home-hero__inner group group--first group--last"
  }, [_c('div', {
    staticClass: "home-hero__content"
  }, [_c('h1', {
    staticClass: "home-hero__heading h1 mt0 fw-semibold",
    domProps: {
      "innerHTML": _vm._s(_vm.hero.heading)
    }
  }), _vm._v(" "), _vm._l((_vm.hero.content), function(copy, index) {
    return _c('p', {
      key: index,
      staticClass: "home-hero__copy p",
      domProps: {
        "innerHTML": _vm._s(copy)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "home-hero__get-started"
  }, [_c('div', {
    staticClass: "home-hero__form"
  }, [_c('h4', {
    staticClass: "h4 mt0"
  }, [_vm._v("Get your dental work verified now")]), _vm._v(" "), _c('module-form', {
    attrs: {
      "form-id": "hero-procedure",
      "fields": {
        procedure: {
          label: "Procedure Type",
          labelHidden: true,
          type: "select",
          placeholder: "Select your procedure",
          items: _vm.items,
        },
      },
      "button": "primary",
      "button-size": "m",
      "submit": "Continue",
      "action": _vm.action
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-756cc88a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/home/Hero.vue
// module id = 247
// module chunks = 0